import MaskedNumberInput, { MaskedNumberInputProps } from 'components/masked-number-input';

import { formatArea } from 'lib/utils';
import { SQ_METER_SIGN } from 'lib/constants';

type AreaInputProps = MaskedNumberInputProps;

const AreaInput: React.FC<AreaInputProps> = (props) => {
  return (
    <MaskedNumberInput
      decimal
      min={1}
      max={1_000}
      sign={SQ_METER_SIGN}
      format={formatArea}
      {...props}
    />
  );
};

export default AreaInput;
